import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
  async getCCMObservationByPatientId (patientId) {
    const response = await _axios.get(
      `/ccmobservation/getbypatientid/${patientId}`,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM Observation by patient ID');
  },
  async getCCMObservationByCCMRecordId (ccmRecordId) {
    try {
      const response = await _axios.get(
        `/ccmobservation/getbyccmrecordid/${ccmRecordId}`,
      );
      if (response.data.resFlag) {
        return response.data;
      }
      throw new CCMError('Error getting CCM Observation by CCM record ID');
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return [];
      }
      throw new CCMError('Error getting CCM Observation by CCM record ID', error);
    }
  },
  async getCCMObservation (id) {
    const response = await _axios.get(`/ccmobservation/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM Observation');
  },
  async addCCMObservation (body) {
    const response = await _axios.post('/ccmobservation', body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error adding CCM Observation');
  },
  async updateCCMObservation (id, body) {
    const response = await _axios.put(`/ccmobservation/${id}`, body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error updating CCM Observation');
  },
  async deleteCCMObservation (id) {
    const response = await _axios.delete(`/ccmobservation/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error deleting CCM Observation');
  },
};
